import ApiClient from "./Api/ApiClient";

class SegmentNameService {
    constructor() {
        this.uri = 'segmentname';
        this.apiClient = new ApiClient();
    }

    async get() {
        try {

            return await this.apiClient.doRequest({
                method: ApiClient.GET,
                uri: this.uri + '?paginate=false&order[name]=asc',
                auth: false,
                expectedStatus: 200,
            });

        } catch (e) {
            throw e;
        }
    }

}

export default SegmentNameService;